module.exports = __webpack_public_path__ + "img/ico-facturas.ce2b26c9.svg";